import { render } from "./ActivitySettingsView.vue?vue&type=template&id=1ce5564c&scoped=true"
import script from "./ActivitySettingsView.vue?vue&type=script&lang=js"
export * from "./ActivitySettingsView.vue?vue&type=script&lang=js"

import "./ActivitySettingsView.vue?vue&type=style&index=0&id=1ce5564c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce5564c"]])

export default __exports__